<template>
  <div ref="booking" class="vld-parent">
    <div :class="'alert alert-' + game.room.nickname">

      <div class="btn-group float-right">
        <button
          type="button"
          class="btn btn-sm btn-light-gray material-icons dropdown-toggle"
          data-toggle="dropdown"
          data-display="static"
          aria-haspopup="true"
          aria-expanded="false">
          settings
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            type="button"
            @click="addParticipantsTab">
            <span class="material-icons mt-2">person_add</span>
            <span style="position:relative; bottom:4px;" class="ml-1">Add Participants</span>
          </button>
        </div>
      </div>

      <div class="alert-heading font-mon">
        <a :href="route('portal.games.show', game.hashid)" class="heading h5">{{ game.room.name }}</a>
      </div>
      <p class="">{{ gameStart }}, group of {{ game.participants }}</p>
      <h5 v-if="game.title" class="font-weight-bold font-italic">&ldquo;{{ game.title }}&rdquo;</h5>
      <table class="table table-bordered table-dark mb-0">
        <thead>
          <tr>
            <th
              scope="col"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Escape Time"
              @click="statsEscape">
              <span class="material-icons">lock_clock</span>
              <button
                type="button"
                class="float-right btn btn-sm btn-light-gray material-icons">
                arrow_downward
              </button>
            </th>
            <th
              scope="col"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Position"
              @click="statsRanks">
              <span class="material-icons">bar_chart</span>
              <button
                type="button"
                class="float-right btn btn-sm btn-light-gray material-icons">
                arrow_downward
              </button>
            </th>
            <th
              scope="col"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Num Photos"
              @click="statsImages">
              <span class="material-icons">panorama</span>
              <button
                type="button"
                class="float-right btn btn-sm btn-light-gray material-icons">
                arrow_downward
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ game.escape | escapeTime }}</td>
            <td>
              <div v-if="game.escape != -1">
                <span class="heading">Now:</span> {{ ranksAllNow }}<br>
                <span class="heading">Then:</span> {{ ranksAllThen }}
              </div>
            </td>
            <td>{{ game.media.length }}</td>
          </tr>
        </tbody>
      </table>
      <div class="bg-white">
        <div v-if="breakdownEscape" class="p-2">
          <p class="mb-0">You escaped in {{ game.escape | escapeTime }}, the average for this room is {{ game.stats.averageEscape | escapeTime }} (<span v-html="escapeDifference(game.escape, game.stats.averageEscape)"></span>)</p>
          <p>You got the quickest time since {{ fastestSinceAllMoment }} ({{ fastestSinceAllMomentAgo }})</p>
          <p class="mb-0">The average escape for this room for {{ game.participants }} players is {{ game.stats.averagePlayersEscape | escapeTime }} (<span v-html="escapeDifference(game.escape, game.stats.averagePlayersEscape)"></span>)</p>
          <p>You got the quickest time since for {{ game.participants }} players since {{ fastestSincePlayersMoment }} ({{ fastestSincePlayersMomentAgo }})</p>
        </div>
        <div v-if="breakdownRanks" class="p-2">
          Check back soon, there will be a graph of your rank over time.
        </div>
        <div v-if="breakdownImages" class="p-2">
          <template v-if="game.media.length">
            <a
              v-for="image in game.media"
              :href="image.url"
              target="_blank">
              <img :src="image.urlThumb">
            </a>
            <a
              :href="route('portal.games.media.download', game.hashid)"
              class="btn btn-yellow my-2">
              Download All
            </a>
          </template>
          <p v-else>No images uploaded</p>
        </div>
        <div v-if="breakdownParticipants" class="p-2">
          <h6 class="heading">The Team:</h6>
          <div v-for="player in game.players">
            <p>{{ player.name }}</p>
          </div>
          <div v-if="game.participant_invites.length">
            <h6 class="heading">Awaiting Confirmation:</h6>
            <div
              v-for="invite in game.participant_invites"
              class="row">
              <div class="col-sm-9">
                <p>{{ invite.participant_email }}</p>
              </div>
              <div class="col-sm-3">
                <button
                  class="btn btn-sm btn-yellow"
                  @click="resendInvite(invite.id)">
                  Resend Invite
                </button>
              </div>
            </div>
          </div>
          <h6 v-if="participantsToAdd" class="heading">Add Team Members:</h6>
          <div v-for="(extraParticipants, i) in range(1, participantsToAdd)">
            <div class="form-group row">
              <label :for="$id('participant' + extraParticipants)" class="col-sm-2 col-form-label">Email {{ i + 1 }}</label>
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control"
                  :id="$id('participant' + extraParticipants)"
                  v-model.trim="addParticipants[i]">
              </div>
            </div>
          </div>
          <div v-if="participantsToAdd" class="row">
            <div class="col text-right">
              <button class="btn btn-green" @click="addTeamMembers">Add Team Members</button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 d-flex justify-content-end">
        <a :href="route('portal.games.show', game.hashid)" class="btn btn-primary text-right">Game Details</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
    initialGame: Object,
  },

  data() {
    return {
      game: Object.assign({}, this.initialGame),

      breakdownEscape: false,
      breakdownRanks: false,
      breakdownImages: false,
      breakdownParticipants: false,

      addParticipants: [],
    };
  },

  computed: {
    ranksAllNow() {
      let outputText = '';
      if (this.game.stats.rankAllNow < 11) {//in the top 10, state this
        outputText += 'Rank ' + this.game.stats.rankAllNow + ' of ' + this.game.stats.totalGames + ' | ';
      }
      outputText += 'Top ' + ((parseInt(this.game.stats.rankAllNow) / parseInt(this.game.stats.totalGames)) * 100).toFixed(1) + '%';
      return outputText;
    },
    ranksAllThen() {
      let outputText = '';
      if (this.game.stats.rankAllThen < 11) {//in the top 10, state this
        outputText += 'Rank ' + this.game.stats.rankAllThen + ' of ' + this.game.stats.totalGamesThen + ' | ';
      }
      outputText += 'Top ' + ((parseInt(this.game.stats.rankAllThen) / parseInt(this.game.stats.totalGamesThen)) * 100).toFixed(1) + '%';
      return outputText;
    },

    fastestSinceAllMoment() {
      if (this.game.stats.fastestSinceAll) {
        return moment(this.game.stats.fastestSinceAll).format('ddd, Do MMM YYYY');
      } else {
        return 'N/A';
      }
    },
    fastestSinceAllMomentAgo() {
      if (this.game.stats.fastestSinceAll) {
        return moment().diff(moment(this.game.stats.fastestSinceAll), 'days') + ' days ago';
      } else {
        return 'N/A';
      }
    },
    fastestSincePlayersMoment() {
      if (this.game.stats.fastestSincePlayers) {
        return moment(this.game.stats.fastestSincePlayers).format('ddd, Do MMM YYYY');
      } else {
        return 'N/A';
      }
    },
    fastestSincePlayersMomentAgo() {
      if (this.game.stats.fastestSincePlayers) {
        return moment().diff(moment(this.game.stats.fastestSincePlayers), 'days') + ' days ago';
      } else {
        return 'N/A';
      }
    },

    gameStart() {
      return moment(this.game.booking.room_slot.start).format('ddd, Do MMM YYYY @ HH:mm')
    },

    resceduleable() {
      return true;
    },

    voucherable() {
      return true;
    },

    participantsToAdd() {
      return (this.game.participants - this.game.players.length - this.game.participant_invites.length);
    },

  },

  watch: {

  },

  methods: {
    range(start, end) { // this is for a v-for, it cannot not start at 0, vueIdiots
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

    statsEscape() {
      this.breakdownEscape = !this.breakdownEscape;
      this.breakdownImages = false;
      this.breakdownRanks = false;
      this.breakdownParticipants = false;
    },
    statsImages() {
      this.breakdownImages = !this.breakdownImages;
      this.breakdownEscape = false;
      this.breakdownRanks = false;
      this.breakdownParticipants = false;
    },
    statsRanks() {
      this.breakdownRanks = !this.breakdownRanks;
      this.breakdownImages = false;
      this.breakdownEscape = false;
      this.breakdownParticipants = false;
    },
    addParticipantsTab() {
      this.breakdownParticipants = !this.breakdownParticipants;
      this.breakdownRanks = false;
      this.breakdownImages = false;
      this.breakdownEscape = false;
    },

    escapeDifference(main, compare) {
      let m = moment.utc(main*1000);
      // console.log('m', m);
      let c = moment.utc(compare*1000);
      // console.log('c', c);
      let duration = moment.duration(c.diff(m));
      let mins = Math.abs(parseInt(duration.asMinutes()) % 60);
      if (mins < 10) {
        mins = '0' + mins;
      }
      let secs = Math.abs(parseInt(duration.asSeconds()) % 60);
      if (secs < 10) {
        secs = '0' + secs;
      }
      let ms = ((parseInt(duration.asSeconds()) * 1000) - parseInt(duration.asMilliseconds())) / 100;
      if (main < compare) {
        return '<span class="text-green">-'+mins+':'+secs+'.'+ms+'</span>';
      } else {
        return '<span class="text-red">+'+mins+':'+secs+'.'+ms+'</span>';
      }
    },

    addTeamMembers() {
      // console.log('addTeamMembers() | this.addParticipants:', this.addParticipants);

      let request = {
        new_emails: this.addParticipants,
      }

      this.loading(true);

      axios.post(this.route('api.games.participants-invites.store', this.game), request)
        .then((response) => {
          if (response.status == 200) {
            // console.log('addTeamMembers axios response data:', response.data);
            flash('Invite(s) sent', 'success');
            this.game = response.data;
          } else {
            flash('Error sending invite(s)', 'danger');
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error on addTeamMembers', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            if (error.response.status == 422) {
              console.log('addTeamMembers: laravel validation error', error.response.data);
            }
            // else if HTTP_CONFLICT
            else if (error.response.status == 409) {
              this.lockError = error.response.data;
            }
            // else if HTTP_FORBIDDEN on enough permissions
            else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addTeamMembers:401', error.response.data);
              window.location.reload();
            }
            else {
              console.log('addTeamMembers: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser an instance
            // http.ClientRequest in node.js
            console.error('addTeamMembers: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addTeamMembers: Error', error.message);
          }

          this.loading(false);
        });
    }, // addTeamMembers

    resendInvite(invite_id) {
      // console.log('resendInvite(invite_id)', invite_id);

      let request = {

      };

      this.loading(true);

      axios.post(this.route('api.games.participants-invites.resend', invite_id), request)
        .then((response) => {
           if (response.status == 204) {
            flash('Invite resent.','success');

          } else {
            flash('Error resending Invite', 'error');
            console.log('resendInvite', response.data);
            console.log('resendInvite', response.status);
            console.log('resendInvite', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error resending Invite', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('resendInvite:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('resendInvite:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('resendInvite:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('resendInvite:401', error.response.data);
              window.location.reload();
            } else {
              console.log('resendInvite: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('resendInvite: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('resendInvite: Error', error.message);
          }
          this.loading(false);
        }); // axios

    },


  },
}
</script>
